import React from 'react';

const AboutUs = () => {
  return (
    <main className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-white overflow-hidden mt-16 sm:mt-20 lg:mt-24">
        {/* Background Layer */}
        <div className="absolute inset-0 bg-[#F9F0F3]">
          <div className="absolute top-0 right-0 w-full lg:w-2/3 h-full bg-[#A47C89]/5" />
          <div className="absolute -top-24 sm:-top-36 lg:-top-48 -right-24 sm:-right-36 lg:-right-48 w-48 sm:w-72 lg:w-96 h-48 sm:h-72 lg:h-96 rounded-full bg-[#FFB6C1]/10" />
          <div className="absolute top-1/4 -left-12 sm:-left-18 lg:-left-24 w-24 sm:w-36 lg:w-48 h-24 sm:h-36 lg:h-48 rounded-full bg-[#A47C89]/10" />
        </div>

        <div className="relative container mx-auto px-4 sm:px-6 py-8 sm:py-12 lg:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8 items-center">
            {/* Text Content */}
            <div className="lg:col-span-5 lg:pr-12">
              <div className="relative">
                <span className="inline-block px-3 sm:px-4 py-1 sm:py-1.5 bg-[#A47C89]/10 rounded-full mb-4 sm:mb-6 text-xs sm:text-sm tracking-wider text-[#A47C89]">
                  ESTABLISHED 2015
                </span>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-light leading-tight mb-4 sm:mb-6">
                  Crafting
                  <span className="block font-playfair italic text-[#A47C89] my-2">Beauty</span>
                  With Purpose
                </h1>
                <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-4 sm:mb-6">
                  Founded with a vision of transforming not just hair, but confidence. 
                  Every strand we style carries the weight of our commitment to excellence 
                  and the lightness of our creative spirit.
                </p>
                <div className="h-px w-16 sm:w-24 bg-[#A47C89]" />
              </div>
            </div>

            {/* Image Grid - Responsive Layout */}
            <div className="lg:col-span-7 relative h-[400px] sm:h-[500px] lg:h-[600px] mt-8 lg:mt-0">
              <div className="absolute inset-0">
                {/* First Image (Large) */}
                <div className="absolute left-0 top-0 w-[75%] sm:w-[65%] h-[300px] sm:h-[400px] lg:h-[500px] z-20">
                  <div className="relative h-full overflow-hidden rounded-lg shadow-xl">
                    <img
                      src="/images/aboutus/styling.jpg"
                      alt="Salon atmosphere"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-[#A47C89]/10" />
                  </div>
                </div>
                
                {/* Second Image (Medium) */}
                <div className="absolute right-0 top-[5%] w-[45%] h-[200px] sm:h-[250px] lg:h-[300px] z-10">
                  <div className="relative h-full overflow-hidden rounded-lg shadow-xl">
                    <img
                      src="/images/aboutus/atmosphere.jpg"
                      alt="Styling detail"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-[#FFB6C1]/10" />
                  </div>
                </div>
                
                {/* Third Image (Small) */}
                <div className="absolute right-[10%] bottom-0 w-[40%] h-[180px] sm:h-[200px] lg:h-[250px] z-30">
                  <div className="relative h-full overflow-hidden rounded-lg shadow-xl">
                    <img
                      src="/images/aboutus/detail.jpg"
                      alt="Salon detail"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-[#A47C89]/10" />
                  </div>
                </div>
              </div>

              {/* Decorative Elements */}
              <div className="absolute -bottom-4 sm:-bottom-6 lg:-bottom-8 -right-4 sm:-right-6 lg:-right-8 w-16 sm:w-24 lg:w-32 h-16 sm:h-24 lg:h-32 rounded-full border-2 border-[#A47C89]/20 -z-10" />
              <div className="absolute -top-4 sm:-top-6 lg:-top-8 -left-4 sm:-left-6 lg:-left-8 w-12 sm:w-18 lg:w-24 h-12 sm:h-18 lg:h-24 rounded-full border-2 border-[#FFB6C1]/20 -z-10" />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section - Fixed Layout */}
        <section className="py-12 sm:py-16 lg:py-24 bg-white relative overflow-hidden">
        <div className="container mx-auto px-4 sm:px-6">
            <div className="mb-8 sm:mb-12 lg:mb-16">
            <span className="text-xs sm:text-sm uppercase tracking-widest text-[#A47C89]">Our Values</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-playfair mt-2">What Drives Us</h2>
            </div>

            {/* Grid layout for larger screens, scroll for mobile */}
            <div className="flex flex-col sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {[
                {
                title: "Artistry",
                description: "Every style is a masterpiece, crafted with precision and creative vision."
                },
                {
                title: "Connection",
                description: "Building relationships that go beyond the chair, creating a community of confidence."
                },
                {
                title: "Evolution",
                description: "Constantly learning, growing, and bringing fresh perspectives to classic beauty."
                }
            ].map((value, index) => (
                <div 
                key={index} 
                className="bg-[#F9F0F3] p-6 sm:p-8 rounded-lg relative group"
                >
                <div className="absolute top-0 left-0 w-1 h-0 bg-[#A47C89] group-hover:h-full transition-all duration-500" />
                <span className="text-4xl sm:text-5xl lg:text-6xl font-thin text-[#A47C89]/20">
                    {(index + 1).toString().padStart(2, '0')}
                </span>
                <h3 className="text-xl sm:text-2xl font-playfair mt-4 mb-4">{value.title}</h3>
                <p className="text-gray-600 text-sm sm:text-base">{value.description}</p>
                </div>
            ))}
            </div>
        </div>
        </section>

      {/* Team Section - Responsive Grid */}
      <section className="py-12 sm:py-16 lg:py-24 bg-[#F9F0F3]">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-playfair">Meet Our Artists</h2>
            <p className="text-base sm:text-lg text-gray-600 mt-4 max-w-xl sm:max-w-2xl mx-auto">
              Each member of our team brings their unique perspective and expertise, 
              creating a symphony of talent dedicated to your transformation.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4 sm:gap-6">
            {[
              {
                name: "Samina Khomusi",
                role: "Master Stylist & Owner",
                specialty: "Precision Cuts & Color Transformation",
                image: "/api/placeholder/600/800",
                colSpan: "lg:col-span-7"
              },
              {
                name: "Lorem Ipsum",
                role: "Color Specialist",
                specialty: "Balayage & Creative Color",
                image: "/api/placeholder/600/800",
                colSpan: "lg:col-span-5"
              },
              {
                name: "Lorem Ipsum",
                role: "Style Expert",
                specialty: "Avant-garde Styling & Updos",
                image: "/api/placeholder/600/800",
                colSpan: "lg:col-span-6 lg:col-start-7"
              }
            ].map((member, index) => (
              <div 
                key={index} 
                className={`relative group ${member.colSpan}`}
              >
                <div className="relative overflow-hidden">
                  <div className="aspect-[3/4]">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                    <h3 className="text-xl sm:text-2xl font-playfair mb-2">{member.name}</h3>
                    <p className="text-white/90 text-sm sm:text-base font-light">{member.role}</p>
                    <p className="text-[#FFB6C1] mt-2 text-sm sm:text-base font-light">{member.specialty}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Philosophy Section - Responsive Layout */}
      <section className="py-12 sm:py-16 lg:py-24 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            <div className="relative">
              <img
                src="/images/aboutus/philosophy.jpg"
                alt="Salon philosophy"
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="absolute top-4 sm:top-6 lg:top-8 -right-4 sm:-right-6 lg:-right-8 w-16 sm:w-24 lg:w-32 h-16 sm:h-24 lg:h-32 bg-[#F9F0F3] rounded-full -z-10" />
              <div className="absolute -bottom-4 sm:-bottom-6 lg:-bottom-8 -left-4 sm:-left-6 lg:-left-8 w-24 sm:w-32 lg:w-48 h-24 sm:h-32 lg:h-48 bg-[#A47C89]/10 rounded-full -z-10" />
            </div>
            <div>
              <span className="text-xs sm:text-sm uppercase tracking-widest text-[#A47C89]">Our Philosophy</span>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-playfair mt-2 mb-6 sm:mb-8">Beauty is an Experience</h2>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-4 sm:mb-6">
                We believe that true beauty emerges from the perfect harmony of 
                technical expertise and artistic vision. Every visit to Cut N Curls 
                is an opportunity to experience transformation that goes beyond the mirror.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                Our commitment to excellence is reflected in every detail, from our 
                carefully curated environment to our personalized consultations and 
                expert techniques.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutUs;